import { brandColor } from '../../util/ColorUtil';
import { useRouter } from 'next/router';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
  replaceGlobalMetrics,
} from '../../util/DataUtil';
import { useEffect, useState } from 'react';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { cleanHTML } from '../utils/htmlUtils';

const NumberList = ({ data, global, width }) => {
  const router = useRouter();
  const isOnlyStats =
    data?.field_number_list_stats?.stats_coloured_fields_type.length ===
      undefined &&
    data?.field_number_list_title[0]?.value === undefined &&
    data?.field_number_list_cta_text[0]?.value === undefined &&
    data?.field_number_list_description[0]?.value === undefined;
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_number_list_title),
    isItUndefined(data?.field_number_list_description)
  ).filter((x) => x)[0];
  const [titleHeight, setTitleHeight] = useState(0);
  const [marginTop, setMarginTop] = useState('0px');

  const alignTitleHeight = () => {
    let titleHeights = document.getElementsByClassName('value');
    let titleCounts = titleHeights.length;
    let max = 0;

    for (let i = 0; i < titleCounts; i++) {
      if (titleHeights[i].clientHeight <= max) {
        continue;
      }

      max = titleHeights[i].clientHeight;
    }

    if (width >= 576) {
      setTitleHeight(max);
    }
  };

  const setMargin = () => {
    setMarginTop(
      data?.field_number_list?.title_text_paragraph_type.length
        ? // (isOnlyStats ? '0px' : (width >= 1220 ? '160px' : '0px')) :
          // '0px')
          isOnlyStats
          ? '0px'
          : '80px'
        : '0px'
    );
  };

  useEffect(() => {
    alignTitleHeight();
    setMargin();
  }, [data, width]);

  const renderStats = (items, global) => {
    if (!items) {
      return '';
    }

    return items.map((item, index) => {
      return (
        <div key={index} className={'stat'}>
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_description_formatted[0]?.value,
                global
              ),
            }}
            className={'value'}
          />
          <span
            dangerouslySetInnerHTML={{
              __html: getObjectValueByMachineName(
                item?.field_value_formatted[0]?.value,
                global
              ),
            }}
            className={'label'}
          />
        </div>
      );
    });
  };

  const renderItems = (items, data, global) => {
    if (!items) {
      return '';
    }

    return items.map((item, index) => {
      return (
        <div key={index} className={'stat'}>
          <span
            style={{
              color: brandColor(data?.field_number_list_font_color[0]?.value),
              backgroundColor: brandColor(
                data?.field_number_list_background_col[0]?.value
              ),
            }}
            className={'index'}
          >
            {index + 1}
          </span>
          {item?.field_title_p[0]?.value && (
            <span
              style={{ height: titleHeight > 0 ? titleHeight : '' }}
              dangerouslySetInnerHTML={{
                __html: global
                  ? replaceGlobalMetrics(item?.field_title_p[0]?.value, global)
                  : '',
              }}
              className={'value'}
            />
          )}
          {item?.field_text_p[0]?.value && (
            <span
              dangerouslySetInnerHTML={{
                __html: global
                  ? replaceGlobalMetrics(item?.field_text_p[0]?.value, global)
                  : '',
              }}
              className={'label'}
            />
          )}
        </div>
      );
    });
  };

  return (
    <div
      className={'number-list'}
      style={{
        backgroundColor: brandColor(
          data?.field_number_list_block_backgrou[0]?.value
        ),
      }}
    >
      <div className={'inner-container'}>
        <div className={'top'}>
          <div className={'left'}>
            {data?.field_number_list_title[0]?.value && (
              <span
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(data?.field_number_list_title[0]?.value)
                  ),
                }}
                className={`${data?.field_number_list_stats?.stats_coloured_fields_type ? 'title width' : 'title'} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              />
            )}
            {data?.field_number_list_description[0]?.value && (
              <span
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(data?.field_number_list_description[0]?.value)
                  ),
                }}
                className={`${data?.field_number_list_stats?.stats_coloured_fields_type ? 'subtitle width' : 'subtitle'} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
              />
            )}
            {data?.field_number_list_cta_text[0]?.value && (
              <button
                className={'a-number-list-link'}
                onClick={() => {
                  router.push(data?.field_number_list_cta_link[0]?.value);
                }}
              >
                {data?.field_number_list_cta_text[0]?.value}
              </button>
            )}
          </div>
          {data?.field_number_list_stats?.stats_coloured_fields_type.length >
            0 && (
            <div
              className={
                'right count-' +
                data?.field_number_list_stats?.stats_coloured_fields_type.length
              }
            >
              {renderStats(
                data?.field_number_list_stats?.stats_coloured_fields_type,
                global
              )}
            </div>
          )}
        </div>
        <div
          className={
            'bottom count-' +
            data?.field_number_list?.title_text_paragraph_type.length
          }
          style={{ marginTop: marginTop }}
        >
          {renderItems(
            data?.field_number_list?.title_text_paragraph_type,
            data,
            global
          )}
        </div>
      </div>
    </div>
  );
};

export default NumberList;
